import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { useSiteInfo } from 'shared'

type Props = {
  questions: number
  currentQuestion: number
}

export const MProgressBar = ({ questions, currentQuestion }: Props) => {
  const { t } = useTranslation('common')
  const siteInfo = useSiteInfo()

  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    setProgress(Math.floor((currentQuestion / questions) * 100))
  }, [questions, currentQuestion])

  if (siteInfo.isUS || siteInfo.isUK) {
    return (
      <div className="w-[75%] md:w-full max-w-2xl pt-20">
        <div className="relative bg-gray-400 rounded h-1">
          <div
            data-progress={`${progress}%`}
            className="h-full rounded relative bg-primary-teal duration-300 after:content-[attr(data-progress)] after:ml-0.5 after:text-red-500 after:block after:absolute after:bottom-2 after:-right-[24px] after:bg-[url('/progress-icon.svg')] after:w-[55px] after:h-[40px] after:bg-no-repeat after:flex after:justify-center after:text-lg after:font-bold after:text-white after:leading-9"
            style={{
              width: `${progress}%`,
            }}
          />
        </div>
        <div className="flex flex-row justify-end pt-1">
          <span className="text-base font-semibold text-white md:text-charcoal">
            {t('quiz-progress')}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full max-w-2xl pt-20 mt-auto">
      <div className="flex flex-row justify-between pb-1">
        <span className="text-base font-semibold text-white md:text-charcoal">
          {t('quiz-progress')}
        </span>
        <span className="text-base font-bold text-primary-teal">
          {progress}%
        </span>
      </div>

      <div className="relative h-2 bg-gray-400 rounded md:h-1">
        <div
          className="h-full rounded bg-primary-teal duration-300"
          style={{
            width: `${progress}%`,
          }}
        />
      </div>
    </div>
  )
}
